<template>
  <Main>
    <template v-slot:breadcrumb>
      <BaseBreadcrumb
        @return="previousPage"
        :items="breadcrumb"
        class="d-none d-sm-flex"
      />
    </template>
    <template v-slot:breadcrumb-mobile>
      <BaseBreadcrumb @return="previousPage" :items="breadcrumb" />
    </template>
    <fragment v-if="form">
      <EndorsementForm
        :form="form"
        @submit="submitNewRequestEndorsement"
        name-button="SOLICITAR"
        @cancel="previousPage"
        is-request-endorsement
        disable-type-endorsement
        is-create
      />
    </fragment>
    <ModalGenericCriticism
      v-model="modal"
      @close="previousPage"
      title="SOLICITAÇÃO DE CANCELAMENTO CRIADA"
      text="Nova solicitação de cancelamento de apólice foi criada com sucesso."
    />
    <ModalCancelEndoserment
      @close="closeModalCancel"
      v-model="modalCancelEndoserment"
      title="SAIR SEM SALVAR"
      text="As alterações não foram salvas. Deseja realmente sair da tela?"
    />
  </Main>
</template>
<script>
import EndorsementForm from "../components/EndorsementForm";
import { formatDateToDDMMYYYY } from "@/utils/formats.js";
import ModalGenericCriticism from "@/modules/quotation/components/ModalGenericCriticism";
import ModalCancelEndoserment from "../../insurance_company/components/ModalCancelInsurance";
import RequestEndorsementMixin from "@/mixins/RequestEndorsementMixin";
export default {
  mixins: [RequestEndorsementMixin],
  data: () => ({
    form: null,
    formatDateToDDMMYYYY,
    breadcrumb: [
      {
        text: "Solicitação de Cancelamento de Apólice",
        to: "policy"
      }
    ],
    modal: false,
    cloneForm: {},
    cancelType: {
      id: "cancelamento_remissao",
      nome: "Cancelamento de Apólice"
    },
    newRequest: true
  }),
  components: {
    EndorsementForm,
    ModalGenericCriticism,
    ModalCancelEndoserment
  }
};
</script>
